// src/Hooks/CisHooks/useCISBoholLabels.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useCISBoholLabels = () => {
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLabels = async () => {
    setLoading(true);
    try {
  const { data } = await axiosApi.get('/cisBohol/labels');
  setLabels(data || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching CIS Bohol labels:', err);
      setError(err.response?.data?.error || 'Failed to fetch labels');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLabels();
  }, []);

  return { labels, loading, error, refetch: fetchLabels };
};

export default useCISBoholLabels;
